import React, { forwardRef } from "react";

const About = ({ t }, ref) => {
  const { bizRef, historyRef, clientRef, mapRef } = ref || {};

  const styles = {
    about: { padding: "0px 0", backgroundColor: "#fff" },
    item: {
      padding: "0", // 이미지가 카드 상단에 딱 붙게 하려면 패딩을 0으로 조정
      backgroundColor: "#f9fafb",
      borderRadius: "24px",
      textAlign: "left",
      overflow: "hidden", // 이미지가 둥근 모서리 밖으로 나가지 않게 설정
      display: "flex",
      flexDirection: "column",
    },
    imageWrapper: {
      width: "100%",
      height: "200px", // 이미지 높이 고정 (취향에 따라 조절 가능)
      backgroundColor: "#e5e8eb", // 이미지 로딩 전 배경색
      overflow: "hidden",
    },
    bizImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover", // 이미지가 영역을 꽉 채우도록 설정
      transition: "transform 0.3s ease",
    },
    textWrapper: {
      padding: "30px", // 글자 부분에만 다시 패딩 부여
    },
    itemTitle: {
      fontSize: "22px",
      fontWeight: "700",
      marginBottom: "12px",
      color: "#333d4b",
    },
    itemText: {
      fontSize: "15px",
      color: "#6b7684",
      lineHeight: 1.6,
    },
    grid: {
      display: "grid",
      // 핵심: 150px 정도로 최소 너비를 줄이면 모바일에서도 한 줄에 2개씩 들어갑니다.
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: "16px", // 모바일에서는 간격도 살짝 줄여주는 게 예쁩니다.
      marginTop: "40px",
    },
    item: {
      padding: "40px",
      backgroundColor: "#f9fafb",
      borderRadius: "24px",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    container: {
      maxWidth: "1000px",
      margin: "0 auto 100px",
      padding: "20px 20px 20px",
      textAlign: "center",
    },
    title: {
      fontSize: "40px",
      fontWeight: "800",
      marginBottom: "16px",
      color: "#191f28",
    },
    desc: {
      fontSize: "18px",
      color: "#4e5968",
      marginBottom: "60px",
      lineHeight: 1.6,
      wordBreak: "keep-all",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "24px",
    },
    item: {
      padding: "40px",
      backgroundColor: "#f9fafb",
      borderRadius: "24px",
      textAlign: "left",
    },
    icon: { fontSize: "32px", marginBottom: "20px", display: "block" },
    itemTitle: {
      fontSize: "22px",
      fontWeight: "700",
      marginBottom: "12px",
      color: "#333d4b",
    },
    itemText: { fontSize: "15px", color: "#6b7684", lineHeight: 1.6 },
    revenueCard: {
      margin: "40px auto 60px",
      padding: "40px",
      background: "linear-gradient(135deg, #5db694ff, #2C5847)",
      borderRadius: "24px",
      color: "white",
      display: "inline-block",
      minWidth: "320px",
    },
    revenueAmount: { fontSize: "36px", fontWeight: "800", display: "block" },
    timelineContainer: {
      maxWidth: "700px",
      margin: "0 auto",
      textAlign: "left",
      padding: "0 20px",
    },
    timelineItem: {
      display: "flex",
      borderBottom: "1px solid #f2f4f6",
      padding: "20px 0",
      alignItems: "center",
    },
    timelineYear: {
      fontSize: "20px",
      fontWeight: "800",
      color: "#2C5847",
      minWidth: "80px",
    },
    timelineDesc: {
      fontSize: "17px",
      color: "#333d4b",
      fontWeight: "500",
      marginLeft: "20px",
    },
    clientGrid: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "60px",
      marginTop: "40px",
      flexWrap: "wrap",
    },
    clientLogo: { height: "80px", maxWidth: "200px", objectFit: "contain" },
    mapWrapper: {
      width: "100%",
      height: "auto", // 이미지 비율에 맞게 조절
      borderRadius: "24px",
      overflow: "hidden",
      marginTop: "40px",
      cursor: "pointer", // 클릭 가능하다는 표시
      boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      transition: "transform 0.2s ease",
    },
    locationImg: {
      width: "100%",
      display: "block",
      objectFit: "cover",
    },
    addressContainer: {
      textAlign: "left",
      display: "inline-block", // 텍스트를 중앙 정렬된 부모 안에서 왼쪽 정렬 유지
      margin: "0 auto 30px",
      fontSize: "25px",
      lineHeight: "1.8",
      color: "#4e5968",
    },
    addressItem: {
      display: "block",
      marginBottom: "4px",
    },
    label: {
      fontWeight: "700",
      color: "#191f28",
      marginRight: "12px",
      display: "inline-block",
      minWidth: "80px", // 라벨 길이를 맞춰서 깔끔하게 정렬
    },
  };

  return (
    <section style={styles.about}>
      <div style={styles.container} ref={bizRef}>
        <h2 style={styles.title}>{t.aboutTitle1}</h2>
        <p style={styles.desc}>{t.aboutDesc1}</p>

        <div style={styles.grid}>
          {[
            { img: "/biz_avn.png", title: t.biz1Title, desc: t.biz1Desc },
            { img: "/biz_tele.png", title: t.biz2Title, desc: t.biz2Desc },
            { img: "/biz_cluster.png", title: t.biz3Title, desc: t.biz3Desc },
            { img: "/biz_breaking.png", title: t.bizTitle4, desc: t.bizDesc4 },
            { img: "/biz_steering.png", title: t.bizTitle5, desc: t.bizDesc5 },
            { img: "/biz_radar.png", title: t.bizTitle6, desc: t.bizDesc6 },
          ].map((item, index) => (
            <div key={index} style={styles.item}>
              {/* 1. 이미지 영역 */}
              <div style={styles.imageWrapper}>
                <img
                  src={item.img}
                  alt={item.title}
                  style={styles.bizImage}
                  onMouseOver={(e) => (e.target.style.transform = "scale(1.1)")}
                  onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
                />
              </div>

              {/* 2. 텍스트 영역 */}
              <div style={styles.textWrapper}>
                <h3 style={styles.itemTitle}>{item.title}</h3>
                <p style={styles.itemText}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={styles.container} ref={historyRef}>
        <h2 style={styles.title}>{t.aboutTitle2}</h2>
        <div style={styles.revenueCard}>
          <span style={{ opacity: 0.9 }}>{t.revenueLabel}</span>
          <span style={styles.revenueAmount}>{t.revenueAmount}</span>
        </div>
        <div style={styles.timelineContainer}>
          {t.historyData.map((item, index) => (
            <div key={index} style={styles.timelineItem}>
              <span style={styles.timelineYear}>{item.year}</span>
              <span style={styles.timelineDesc}>{item.desc}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={styles.container} ref={clientRef}>
        <h2 style={styles.title}>{t.clientTitle}</h2>
        <div style={styles.clientGrid}>
          <img src="/customer_LG.png" alt="LG" style={styles.clientLogo} />
          <img
            src="/customer_Mobis.png"
            alt="Mobis"
            style={styles.clientLogo}
          />
          <img
            src="/customer_Klemove.png"
            alt="Klemove"
            style={styles.clientLogo}
          />
        </div>
      </div>

      {/* 4. 찾아오시는 길 */}
      <div style={styles.container} ref={mapRef}>
        <h2 style={styles.title}>{t.mapTitle}</h2>

        {/* 주소 정보 영역 */}
        <div style={styles.addressContainer}>
          <div style={styles.addressItem}>
            <span style={styles.label}>{t.addressLabel}</span>
            <span>{t.addressValue}</span>
          </div>
          <div style={styles.addressItem}>
            <span style={styles.label}>{t.faxLabel}</span>
            <span>{t.faxValue}</span>
          </div>
          <div style={styles.addressItem}>
            <span style={styles.label}>{t.telLabel}</span>
            <span>{t.telValue}</span>
          </div>
        </div>

        {/* 지도 이미지 영역 */}
        <a
          href="https://naver.me/GdycyI5Y"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <div
            style={styles.mapWrapper}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "scale(1.01)")
            }
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <img
              src="/location.png"
              alt="Location Map"
              style={styles.locationImg}
            />
          </div>
        </a>
      </div>
    </section>
  );
};

export default forwardRef(About);
